module.exports = __webpack_public_path__ + "img/white-logo.b540f8ad.png";